import React from 'react'
import CampaignWizard from '../../campaign-wizard/CampaignWizard'

function CreateSmsNewsletter() {
    const steps = [
        { id: 1, title: 'Select Template', subtitle: 'Choose a template or start blank', component: 'TemplateSelection' },
        { id: 2, title: 'Campaign Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Message Content', subtitle: 'SMS message content', component: 'MessageContent' },
        { id: 4, title: 'Patient List', subtitle: 'Select patient that will receive SMS', component: 'PatientList' },
        { id: 5, title: 'Complete', subtitle: 'Process the Campaign', component: 'Complete' }
    ]

    const handleSubmit = (formData) => {
        console.log('SMS Newsletter submitted:', formData)
        // Navigate back to list page
        window.history.back()
    }

    return (
        <CampaignWizard
            title="Create SMS Newsletter"
            description="Send regular updates and news to your patients via SMS."
            navigatePath="/newsletter/sms"
            campaignType="sms"
            steps={steps}
            onSubmit={handleSubmit}
        />
    )
}

export default CreateSmsNewsletter
